import React from 'react';
import c from 'classnames';

import {
  Menu,
  CoreLink,
} from '@uncinc/react-drupal-core';

const ContactFooterMenu = ({ currentPage }) => {
  return (
    <Menu id="footer">
      {(items) => {
        return (
          <div className="Footer__menus row">
            {items.map((item) => {
              if (item) {
                const title = item.getIn(['link', 'title'], 'Untitled');

                return (
                  <div
                    key={title}
                    className="col-12 col-md-6 col-lg-3 Footer__menu__item"
                  >
                    <h4 className="FooterMenu__item__title">{title}</h4>

                    {item.get('subtree') && item.get('subtree').map((subItem, index) => {
                      if (subItem) {
                        const className = subItem.getIn(['link', 'options', 'attributes', 'class', 0]);
                        const subItemTitle = subItem.getIn(['link', 'title'], 'Untitled');
                        const url = subItem.getIn(['link', 'url'], '');
                        const active = subItem.getIn(['link', 'url']) === currentPage;
                        const FooterSubMenuItemClassnames = c('FooterSubMenu__item', className, {
                          'FooterSubMenu__item--active': active,
                          'icon-before': className,
                        });

                        return (
                          <div
                            key={subItemTitle}
                            className={FooterSubMenuItemClassnames}
                          >
                            <CoreLink
                              className="FooterSubMenu__item__link"
                              to={url}
                            >
                              <span className="FooterSubMenu__item__title">{subItemTitle}</span>
                            </CoreLink>
                          </div>
                        );
                      }
                    })}
                  </div>
                );
              }
            })}
          </div>
        );
      }}
    </Menu>
  );
};

export default ContactFooterMenu;
